import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { RouterOutlet, ChildrenOutletContexts } from "@angular/router";
import { slideInAnimation } from "@shared/animations/my-route-animation";

@Component({
  selector: "app-minimal-layout",
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="minimal-route-outlet" [@routeAnimation]="getAnimationData()">
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [
    `
      .minimal-route-outlet {
        position: relative;
        min-height: calc(100dvh - 180px);
      }
    `,
  ],
  animations: [slideInAnimation],
  imports: [RouterOutlet],
})
export class MinimalLayoutComponent {
  private readonly contexts: ChildrenOutletContexts = inject(ChildrenOutletContexts);

  getAnimationData(): string | undefined {
    return this.contexts.getContext("primary")?.route?.snapshot?.data?.["animation"];
  }
}
